import _ from 'lodash';
import { set, get } from 'utils/LocalStorageUtil';

const ACCEPTED_TERMS = 1;

const validateParams = newSession => {
  const entries = Object.entries(newSession);
  const values = Object.values(newSession);

  values.forEach((value, i) => {
    if (!value) throw new Error(`invalid value at ${entries[i]}`);
  });
};

const setObjectToStore = (storeItemName, newObjValues) => {
  const currentValue = get(storeItemName);

  if (!currentValue) throw new Error(`invalid value at ${storeItemName}`);

  const newValue = _.merge(currentValue, newObjValues);

  set(storeItemName, newValue);
};

/**
 * When the API service GET /services/user/settermsandconditions is called,
 * a new session is generated on we need to update the localStorage with those new values.
 *
 * @param {Object} newSession - The new values from the response of settermsandconditions
 * @param {string} newSession.session_stringvalue
 * @param {string} newSession.session_userhash
 * @param {string} newSession.user_token
 * @param {string} newSession.user_session
 */
export const localStorageUpdateSession = newSession => {
  validateParams(newSession);

  try {
    setObjectToStore('getUserInfo', {
      user_hash: newSession.session_userhash,
      token: newSession.user_token,
    });

    setObjectToStore('loginInfo.logged_user_data', {
      token: newSession.user_token,
      acceptTerms: ACCEPTED_TERMS,
      session_stringvalue: newSession.session_stringvalue,
    });

    setObjectToStore('startHeaderInfoResponse', {
      response: {
        session_stringvalue: newSession.session_stringvalue,
      },
    });

    localStorage.setItem('loginInfo.userhash', newSession.session_userhash);
    localStorage.setItem('PHPSESSID', newSession.session_stringvalue);
  } catch (error) {
    throw error('localStorageUpdateSession error: ', error);
  }
};
